export const RATING_OPTIONS = [
  { value: '10', label: '10 - Joining this month' },
  { value: '9',  label: '9 - Joining next month' },
  { value: '8',  label: '8 - Joining in 2 months' },
  { value: '7',  label: '7 - Joining in 3 months' },
  { value: '6',  label: '6 - Good meeting' },
  { value: '5',  label: '5 - Meeting could have gone better' },
  { value: '4',  label: '4 - No meeting' },
];
